// extracted by mini-css-extract-plugin
export default {"loader":"TiktokLoading_loader__9Nf2M","revolve":"TiktokLoading_revolve__ZHVpz"};